(function () {
  if (customElements.get('alb-pg-slider')) return;
  customElements.define('alb-pg-slider', class extends HTMLElement {
    connectedCallback() {
      /* Ab der zweiten Instanz auf der Seite ist das Element schon definiert, wenn der
         Parser das Start-Tag erreicht – die Kinder sind dann noch nicht da. In dem Fall
         Init verschieben (DOM fertig bzw. nächster Frame), sonst blieben Pfeile ohne
         Zustand (linker Pfeil sichtbar, Höhe auf Fallback). */
      if (this.albInit) return;
      var self = this;
      if (!this.querySelector('[data-track]')) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { self.albSetup(); }, { once: true });
        } else {
          window.requestAnimationFrame(function () { self.albSetup(); });
        }
        return;
      }
      this.albSetup();
    }
    albSetup() {
      if (this.albInit) return;
      var self = this;
      this.track = this.querySelector('[data-track]');
      this.prev  = this.querySelector('[data-prev]');
      this.next  = this.querySelector('[data-next]');
      /* Mobile Scroll-Linie (optional, nur wenn die Section sie ausgibt) */
      this.bar   = this.querySelector(':scope > .alb-pg-bar');
      if (!this.track) return;
      this.albInit = true;
      function step(dir) {
        var card = self.track.querySelector('.alb-pg-card');
        var w = card ? card.getBoundingClientRect().width : self.track.clientWidth * 0.8;
        var cs = getComputedStyle(self.track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 16;
        self.track.scrollBy({ left: dir * (w + gap), behavior: (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth' });
      }
      if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
      if (this.next) this.next.addEventListener('click', function () { step(1); });
      /* Scroll-Linie: gleich große Schritte. Jeder Einrastpunkt (Karte am linken Rand, zuletzt
         das Ende der Spur) bekommt eine gleichmäßige Position; dazwischen gleitet der Balken
         stufenlos mit. Die echte Strecke wäre am Ende kürzer, weil die letzte Karte bei z. B.
         1,3 sichtbaren nie links einrasten kann (Moritz, 2026-09-24: gleichmäßig verteilt). */
      var barP = null;
      function points() {
        var t = self.track, max = t.scrollWidth - t.clientWidth;
        var tr = t.getBoundingClientRect();
        var pad = parseFloat(getComputedStyle(t).scrollPaddingLeft) || 0;
        var P = [];
        Array.prototype.forEach.call(t.children, function (c) {
          if (!c.classList.contains('alb-pg-card') || c.offsetParent === null) return; /* ausgeblendete Karten */
          var x = c.getBoundingClientRect().left - tr.left + t.scrollLeft - pad;
          x = Math.max(0, Math.min(max, x));
          if (!P.length || x - P[P.length - 1] > 2) P.push(x);
        });
        if (!P.length || max - P[P.length - 1] > 2) P.push(max);
        return P;
      }
      function drawBar() {
        if (!self.bar) return;
        var t = self.track, max = t.scrollWidth - t.clientWidth;
        var none = max <= 2 || t.clientWidth === 0;
        self.bar.classList.toggle('is-off', none);
        if (none || getComputedStyle(self.bar).display === 'none') return;
        if (!barP) barP = points();
        var k = barP.length; if (k < 2) return;
        var x = t.scrollLeft, i = 0;
        while (i < k - 2 && x > barP[i + 1]) i++;
        var seg = barP[i + 1] - barP[i];
        var f = seg > 0 ? Math.max(0, Math.min(1, (x - barP[i]) / seg)) : 0;
        var w = 100 / k, th = self.bar.firstElementChild;
        th.style.width = w + '%';
        th.style.left = ((i + f) / (k - 1) * (100 - w)) + '%';
      }
      function update() {
        var max = self.track.scrollWidth - self.track.clientWidth - 1;
        var x = self.track.scrollLeft;
        /* Ruheposition ist nicht immer 0: Scroll-Snap richtet die erste Karte am
           scroll-padding aus, die Spur hat aber eigenes padding (gemessen 18px) –
           "am Anfang" = innerhalb dieses Versatzes (+2px Toleranz). */
        var cs0 = getComputedStyle(self.track);
        var rest = Math.max(0, (parseFloat(cs0.paddingLeft) || 0) - (parseFloat(cs0.scrollPaddingLeft) || 0));
        if (self.prev) self.prev.disabled = x <= rest + 2;
        if (self.next) self.next.disabled = x >= max;
        self.classList.toggle('alb-pg-nonav', self.track.scrollWidth <= self.track.clientWidth + 2);
        /* Links erst ausblenden, wenn wirklich über die Ruheposition hinaus gescrollt wurde */
        self.track.classList.toggle('alb-pg-fade-l', x > rest + 2);
        self.track.classList.toggle('alb-pg-fade-r', x < max - 2);
        drawBar();
      }
      function relayout() { barP = null; update(); placeArrows(); }
      /* Pfeile vertikal auf die Mitte des Kartenbilds legen (nicht der ganzen Karte) */
      function placeArrows() {
        var media = self.track.querySelector('.alb-pg-media');
        if (!media) return;
        var sr = self.getBoundingClientRect(), mr = media.getBoundingClientRect();
        if (mr.height > 0) self.style.setProperty('--alb-pg-arrow-top', Math.round(mr.top - sr.top + mr.height / 2) + 'px');
      }
      this.track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', relayout, { passive: true });
      /* Zustand auch nachziehen, wenn sich die Spur ohne Scroll aendert (Bilder/Fonts laden,
         Editor-Rerender) – sonst bleibt der Init-Stand (noch ohne Layout) haengen. */
      if (window.ResizeObserver) { new ResizeObserver(relayout).observe(this.track); }
      window.addEventListener('load', relayout);
      update(); placeArrows();
    }
  });
})();
